module.exports = __webpack_public_path__ + "22a79ff55c71b75be85a3d75951dec46.jpg";